module.exports = __webpack_public_path__ + "static/media/sidebar-users.87c01e70.svg";